import shuffleArray from '@/services/shuffleArray'

export const getters = {
    getArticles: state => shuffleArray(state.items).filter((item, index) => index < 3)
}